import { LabelFieldType } from "shared/types";

const TextLabel = ({ className, id, label, type }: LabelFieldType) => {
  return (
    <p id={id} className={className} data-type={type}>
      {label}
    </p>
  );
};
export default TextLabel;
